import { useMemo, useState } from "react";
import { Tag as TagIcon, Plus, X } from "lucide-react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "../../../../components/UI/Popover";

const withAlpha = (hex, alphaHex) => {
  if (!hex || typeof hex !== "string") return undefined;
  const normalized = hex.startsWith("#") ? hex : `#${hex}`;
  if (normalized.length === 7) return `${normalized}${alphaHex}`;
  return normalized;
};

const TagChipsBar = ({
  selectedChat,
  tags = [],
  tagZalos = [],
  onRemoveAkabizTag,
  onRemoveZaloTag,
  onAdd,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const akabizAssigned = useMemo(() => {
    const ids = selectedChat?.tagIds || [];
    return tags.filter((t) => t.isActive && ids.includes(t._id));
  }, [tags, selectedChat]);

  const zaloAssigned = useMemo(() => {
    const uid = selectedChat?.uid;
    if (!uid) return [];
    return tagZalos.filter((t) => t.conversations?.includes(uid));
  }, [tagZalos, selectedChat]);

  const handlePick = (type) => {
    setMenuOpen(false);
    setTimeout(() => onAdd?.(type), 80);
  };

  if (!selectedChat) return null;

  return (
    <div className="flex items-center flex-wrap gap-1.5 px-2 py-1.5 border-b border-gray-100 bg-gray-50/60">
      <TagIcon size={14} className="text-gray-400 shrink-0" />

      {akabizAssigned.map((tag) => (
        <span
          key={`akabiz-${tag._id}`}
          className="group inline-flex items-center gap-1 rounded-full px-2 py-[2px] text-[11px] font-medium border"
          style={{
            backgroundColor: withAlpha(tag.color, "26"),
            color: tag.color,
            borderColor: withAlpha(tag.color, "40"),
          }}
          title={tag.name}
        >
          <span className="max-w-[140px] truncate">{tag.name}</span>
          <button
            type="button"
            aria-label={`Gỡ nhãn ${tag.name}`}
            title="Gỡ nhãn"
            onClick={() => onRemoveAkabizTag?.(tag)}
            className="opacity-0 group-hover:opacity-100 transition p-0.5 rounded-full hover:bg-black/10"
          >
            <X size={11} />
          </button>
        </span>
      ))}

      {zaloAssigned.map((tag) => (
        <span
          key={`zalo-${tag._id}`}
          className="group inline-flex items-center gap-1 rounded-full px-2 py-[2px] text-[11px] font-medium border border-dashed"
          style={{
            color: tag.color,
            borderColor: tag.color,
            backgroundColor: withAlpha(tag.color, "14"),
          }}
          title={`Zalo • ${tag.text}`}
        >
          <span className="max-w-[140px] truncate">{tag.text}</span>
          <button
            type="button"
            aria-label={`Gỡ tag Zalo ${tag.text}`}
            title="Gỡ tag Zalo"
            onClick={() => onRemoveZaloTag?.(tag)}
            className="opacity-0 group-hover:opacity-100 transition p-0.5 rounded-full hover:bg-black/10"
          >
            <X size={11} />
          </button>
        </span>
      ))}

      <Popover open={menuOpen} onOpenChange={setMenuOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            aria-label="Thêm nhãn"
            title="Thêm nhãn"
            className="inline-flex items-center justify-center rounded-full w-[22px] h-[22px] border border-dashed border-gray-300 text-gray-400 hover:border-gray-500 hover:text-gray-700 transition"
          >
            <Plus size={12} strokeWidth={2.2} />
          </button>
        </PopoverTrigger>
        <PopoverContent
          align="start"
          sideOffset={4}
          className="w-44 p-1"
        >
          <button
            type="button"
            onClick={() => handlePick("akabiz")}
            className="w-full flex items-center gap-2 px-2 py-1.5 text-sm text-left rounded-md hover:bg-gray-100"
          >
            <span className="inline-block w-2 h-2 rounded-full bg-red-500" />
            <span>Tag cài đặt</span>
          </button>
          <button
            type="button"
            onClick={() => handlePick("zalo")}
            className="w-full flex items-center gap-2 px-2 py-1.5 text-sm text-left rounded-md hover:bg-gray-100"
          >
            <span className="inline-block w-2 h-2 rounded-full border border-dashed border-blue-500" />
            <span>Tag Zalo</span>
          </button>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default TagChipsBar;
